export default __webpack_public_path__ + "static/media/logo@3x.460f9228.png";